import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import {
	Checkbox,
	CircularProgress,
	FormControl,
	FormControlLabel,
	FormGroup,
	InputLabel,
	MenuItem,
	Select
} from "@mui/material";
import SettingsActions from "redux-react/actions/settingsActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import i18n from "i18n";

/**
 * Right pannel link a dictionary
 * @param {*} param0
 * @returns
 */
const PannelDictionary = ({ values, handleInputChange }) => {
	const user = useSelector(state => state.user);
	const profile = useSelector(selectCurrentProfile);
	const language = profile?.language || user?.language || "FR";

	const dispatch = useDispatch();

	const [dictionaries, setDictionaries] = useState({});
	const [loading, setLoading] = useState(true);

	const getDictionaries = () => {
		dispatch(
			SettingsActions.getDictionaries(
				res => {
					setDictionaries(res.dictionaries);
					setLoading(false);
				},
				() => {
					setLoading(false);
					setDictionaries({});
				}
			)
		);
	};

	useEffect(() => {
		getDictionaries();
	}, []);

	return (
		<MDBox display="flex" flex="1">
			<div style={{ borderLeft: "1px solid #ccc", height: "100%", margin: "0 10px" }} />
			<MDBox display="flex" flexDirection="column" width="100%">
				<MDBox sx={{ mb: 1 }}>
					<MDTypography variant="h6">Parametrer le dictionnaire</MDTypography>

					{loading && (
						<MDBox
							display="flex"
							flexDirection="column"
							justifyContent="center"
							alignItems="center"
							mt={2}
						>
							<MDTypography variant="body2" color="textSecondary">
								Chargement des dictionnaires
							</MDTypography>
							<CircularProgress size={36} color="info" />
						</MDBox>
					)}
					{!loading && (
						<MDBox mt={2}>
							<FormControl fullWidth>
								<InputLabel id="select-label">Dictionnaire</InputLabel>
								<Select
									labelId="select-label"
									id="select"
									label="Dictionnaire"
									value={values?.config?.dictionary || ""}
									onChange={e => {
										let event = {
											target: {
												name: "config.dictionary",
												value: e.target.value
											}
										};
										handleInputChange(event);
									}}
								>
									{Object.keys(dictionaries).map((key, index) => {
										let dictionary = dictionaries[key];
										let name = dictionary.label[language.toLowerCase()];

										return (
											<MenuItem key={index} value={key}>
												{name ?? key}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
							<FormGroup>
								<FormControlLabel
									control={
										<Checkbox
											checked={values?.config?.keepAttributeFromParent === true}
											onClick={e => {
												let event = {
													target: {
														name: "config.keepAttributeFromParent",
														value: e.target.checked
													}
												};
												handleInputChange(event);
											}}
										/>
									}
									label={i18n.t("FORMS.keepAttributeFromParent")}
								/>
							</FormGroup>
						</MDBox>
					)}
				</MDBox>
			</MDBox>
		</MDBox>
	);
};

export default PannelDictionary;
